import { Heading, Text } from '@iziwork/design-system';
import React, { FC } from 'react';
import styled from 'styled-components';

import { ErrorLogo } from '~/components/Error/ErrorLogo';
import { ErrorTemplate } from '~/components/Error/ErrorTemplate';
import { MissionNotFoundError } from '~/components/Error/MissionNotFoundError';
import { useRouter, useTranslation } from '~/hooks';

const ErrorSub = styled(Text)`
  display: block;
  font-size: 1rem;
  margin-top: 1rem;
  text-align: left;
  color: ${({ theme }) => theme.colors?.info?.normal};
  @media (min-width: ${({ theme }) => theme.devices.tablet.min}) {
    text-align: center;
  }
  &:first-of-type {
    margin-top: 2.5rem;
  }
`;

export const NotFoundError: FC = () => {
  const { query } = useRouter();
  if (query.slug) {
    return <MissionNotFoundError />;
  }

  const { t } = useTranslation();
  return (
    <ErrorTemplate title={t('title.404_error')}>
      <ErrorLogo prefix="4" suffix="4" />
      <Heading variant="heading-3">{t('error_pages.not_found_title')}</Heading>
      <ErrorSub variant="body-lighter">{t('error_pages.not_found_subtitle1')}</ErrorSub>
      <ErrorSub variant="body-lighter">{t('error_pages.not_found_subtitle2')}</ErrorSub>
    </ErrorTemplate>
  );
};
